export const DEFAULT_KEY_ORDER = 9999999;
export const CASH_PURCHASE_ONLY_DISCOUNT = '%';
export const DRIVE_TRAIN_4WD = '4WD';
export const CAB_SIZE_REGULAR = 'RC';
export const CAB_SIZE_EXTENDED = 'XC';
export const CAB_SIZE_CREW = 'CC';
export const BOX_SIZE_SHORT = 'SB';
export const BOX_SIZE_LONG = 'LB';

export const CAB_SIZE_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 1,
    DESCRIPTION: 2,
    CODE: 3,
};

export const BOX_SIZE_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 1,
    DESCRIPTION: 2,
    CODE: 3,
};

export const DRIVE_TRAIN_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 2,
    DESCRIPTION: 1,
    CODE: 3,
    LONG_DESCRIPTION: 4,
};

export const ENGINE_DATA = {
    FUEL: 0,
    CYLINDERS: 1,
    DISPLACEMENT: 2,
    IS_TURBO: 3,
    HP: 4,
    HP_RPM: 5,
    TORQUE: 6,
    TORQUE_RPM: 7,
};

export const TRANSMISSION_DATA = {
    TYPE_CODE: 0,
    TYPE: 1,
    SPEEDS: 2,
    IS_CVT: 3,
    DESCRIPTION: 4,
};

export const COLOUR_DATA = {
    CODE: 0,
    TILE: 1,
    PHOTO_1: 2,
    PHOTO_2: 3,
    PHOTO_3: 4,
    PRICING: 5,

    AMOUNTS: {
        RETAIL: 0,
        RESIDUAL_RETAIL: 1,
    },

    FEATURE_FABRIC: 0,
    FEATURE_INTERIOR: 1,
    FEATURE_SEAT: 2,
};

export const MODEL_CONFIGURATION = {
    BIT_FIELD: 0,
    TRIM_CODE: 1,
    TRIM_RANK: 2,
    ID: 3,
    RANK: 4,
    DESCRIPTION: 5,
    SEATING: 6,
    FUEL_CONSUMPTION: 7,
    ENGINE: 8,
    TRANSMISSION: 9,
    PACKAGE_CODE: 10,
    PACKAGE: 11,
    OPTION_CODES: 12,
    URL_EXTERIOR_COLOUR: 13,
    URL_INTERIOR_TRIM: 14,
    PRICING: 15,
    FINANCE: 16,
    LEASE: 17,
    CAR_ID: 18,
    VEH_ID: 19,
    EXTERIOR_COLOUR_STATUS: 20,
    TAXES_FACTOR: 21,
    TAX_CODES: 22,
};

export default {
    DEFAULT_KEY_ORDER,
    CASH_PURCHASE_ONLY_DISCOUNT,
    DRIVE_TRAIN_4WD,
    CAB_SIZE_REGULAR,
    CAB_SIZE_EXTENDED,
    CAB_SIZE_CREW,
    CAB_SIZE_DATA,
    BOX_SIZE_DATA,
    BOX_SIZE_SHORT,
    BOX_SIZE_LONG,
    DRIVE_TRAIN_DATA,
    ENGINE_DATA,
    TRANSMISSION_DATA,
    COLOUR_DATA,
    MODEL_CONFIGURATION,
};



// WEBPACK FOOTER //
// ./src/constants/dataConversions.js